import { ReactComponent as Logo } from "../../assets/dist/logo_dark.svg";
import { ReactComponent as LogoAIS } from "../../assets/dist/logo_ais_dark.svg";
import { ReactComponent as LogoGameloft } from "../../assets/dist/logo_gameloft.svg";

import { ReactComponent as MultiPlayer } from "../../assets/dist/ic_multiplayer_dark.svg";
import { ReactComponent as MultiPlayerActive } from "../../assets/dist/ic_multiplayer_active.svg";
import { ReactComponent as Gamepad } from "../../assets/dist/ic_gamepad_dark.svg";
import { ReactComponent as GamepadActive } from "../../assets/dist/ic_gamepad_active.svg";
import { ReactComponent as Touch } from "../../assets/dist/ic_touch_dark.svg";
import { ReactComponent as TouchActive } from "../../assets/dist/ic_touch_active.svg";
import { ReactComponent as KeyboardMouse } from "../../assets/dist/ic_keyboard_mouse_dark.svg";
import { ReactComponent as KeyboardMouseActive } from "../../assets/dist/ic_keyboard_mouse_active.svg";
import { ReactComponent as TvRemote } from "../../assets/dist/ic_tv_remote_dark.svg";
import { ReactComponent as TvRemoteActive } from "../../assets/dist/ic_tv_remote_active.svg";

import { ReactComponent as Account } from "../../assets/dist/ic_account_dark.svg";
import { ReactComponent as AccountActive } from "../../assets/dist/ic_account_active_dark.svg";

import { ReactComponent as TimerShort } from "../../assets/dist/ic_short_time_dark.svg";
import { ReactComponent as TimerShortActive } from "../../assets/dist/ic_short_time_active.svg";

import { ReactComponent as TimerMedium } from "../../assets/dist/ic_medium_time_dark.svg";
import { ReactComponent as TimerMediumActive } from "../../assets/dist/ic_medium_time_active.svg";

import { ReactComponent as TimerLong } from "../../assets/dist/ic_long_time_dark.svg";
import { ReactComponent as TimerLongActive } from "../../assets/dist/ic_long_time_active.svg";

import { ReactComponent as Plans } from "../../assets/dist/ic_plans_dark.svg";
import { ReactComponent as PlansActive } from "../../assets/dist/ic_plans_active_dark.svg";

import { ReactComponent as Newsletter } from "../../assets/dist/ic_newsletter_dark.svg";
import { ReactComponent as NewsletterActive } from "../../assets/dist/ic_newsletter_active_dark.svg";

import { ReactComponent as Receipt } from "../../assets/dist/ic_receipt_dark.svg";
import { ReactComponent as ReceiptActive } from "../../assets/dist/ic_receipt_active_dark.svg";

import { ReactComponent as Settings } from "../../assets/dist/ic_settings_dark.svg";
import { ReactComponent as SettingsActive } from "../../assets/dist/ic_settings_active_dark.svg";

import { ReactComponent as Link } from "../../assets/dist/ic_link_dark.svg";
import { ReactComponent as LinkActive } from "../../assets/dist/ic_link_active_dark.svg";

import { ReactComponent as Faq } from "../../assets/dist/ic_faq_dark.svg";
import { ReactComponent as FaqActive } from "../../assets/dist/ic_faq_active_dark.svg";

import { ReactComponent as Discord } from "../../assets/dist/ic-discord-white.svg";

import { ReactComponent as Support } from "../../assets/dist/ic_support_dark.svg";
import { ReactComponent as SupportActive } from "../../assets/dist/ic_support_active_dark.svg";

import { ReactComponent as Visibility } from "../../assets/dist/ic_visibility_dark.svg";
import { ReactComponent as VisibilityOff } from "../../assets/dist/ic_visibility_off_dark.svg";

import { ReactComponent as Notification } from "../../assets/dist/ic_notification_dark.svg";
import { ReactComponent as NotificationActive } from "../../assets/dist/ic_notification_active_dark.svg";

import { ReactComponent as LightTheme } from "../../assets/dist/ic_light_theme_dark.svg";
import { ReactComponent as LightThemeActive } from "../../assets/dist/ic_light_theme_active_dark.svg";

import { ReactComponent as DarkTheme } from "../../assets/dist/ic_dark_theme_dark.svg";
import { ReactComponent as DarkThemeActive } from "../../assets/dist/ic_dark_theme_active_dark.svg";

import { ReactComponent as SwitchProfile } from "../../assets/dist/ic_switch_profile_dark.svg";
import { ReactComponent as SwitchProfileActive } from "../../assets/dist/ic_switch_profile_active_dark.svg";

import { ReactComponent as SortAZ } from "../../assets/dist/ic_sort_a_z.svg";
import { ReactComponent as SortAZDark } from "../../assets/dist/ic_sort_a_z_dark.svg";
import { ReactComponent as SortAZActive } from "../../assets/dist/ic_sort_a_z_active.svg";

import { ReactComponent as SortDate } from "../../assets/dist/ic_sort_date.svg";
import { ReactComponent as SortDateDark } from "../../assets/dist/ic_sort_date_dark.svg";
import { ReactComponent as SortDateActive } from "../../assets/dist/ic_sort_date_active.svg";

import { ReactComponent as SortGenre } from "../../assets/dist/ic_sort_genre.svg";
import { ReactComponent as SortGenreDark } from "../../assets/dist/ic_sort_genre_dark.svg";
import { ReactComponent as SortGenreActive } from "../../assets/dist/ic_sort_genre_active.svg";

import { ReactComponent as NotificationsPush } from "../../assets/dist/notification_active_dark.svg";

import { ReactComponent as Speedtest } from "../../assets/dist/ic_speed_test_dark.svg";
import { ReactComponent as SpeedtestActive } from "../../assets/dist/ic_speed_test_dark_active.svg";

import { ReactComponent as PEGI_12 } from "../../assets/dist/ic_12years_dark.svg";
import { ReactComponent as PEGI_16 } from "../../assets/dist/ic_16years_dark.svg";
import { ReactComponent as PEGI_18 } from "../../assets/dist/ic_18years_dark.svg";
import { ReactComponent as PEGI_3 } from "../../assets/dist/ic_3years_dark.svg";
import { ReactComponent as PEGI_7 } from "../../assets/dist/ic_7years_dark.svg";

import { ReactComponent as PEGI_12_Active } from "../../assets/dist/ic_12years_active.svg";
import { ReactComponent as PEGI_16_Active } from "../../assets/dist/ic_16years_active.svg";
import { ReactComponent as PEGI_18_Active } from "../../assets/dist/ic_18years_active.svg";
import { ReactComponent as PEGI_3_Active } from "../../assets/dist/ic_3years_active.svg";
import { ReactComponent as PEGI_7_Active } from "../../assets/dist/ic_7years_active.svg";
import { ReactComponent as NewsletterIcon } from "../../assets/dist/newsletter_dark.svg";
import { ReactComponent as MultiDevice } from "../../assets/dist/multi-devices_dark.svg";

import {
  BottomBarStyle,
  ButtonStyle,
  CardStyle,
  NamedTheme,
  NotificationInstall,
  TextInputStyle,
  ToggleButtonStyle,
} from "../Theme";

export const createDarkTheme = (opts: {
  colorAccent: string;
  primaryTextColor?: string;
}) => {
  const { colorAccent, primaryTextColor = "#FFFFFF" } = opts;

  const cardStyle: Partial<CardStyle> = {
    inactiveBackgroundColor: "#3C3C3C",
    secondaryBackgroundColor: "#454545",
    inactiveTextColor: primaryTextColor,
    inactiveTextColorLight: "#FFFFFF",
    inactiveBorderColor: "#3C3C3C",
    activeBackgroundColor: colorAccent,
    activeBorderColor: colorAccent,
    activeTextColor: primaryTextColor,
    radius: 0.6,
    scaleFactor: 1.1,
  };

  const textInputStyle: Partial<TextInputStyle> = {
    labelStyle: {
      inactiveFontSize: 15,
      activeFontSize: 12,
      activeColor: primaryTextColor,
      inactiveColor: primaryTextColor,
    },

    helperStyle: {
      size: 12,
      color: "#fff",
    },

    errorColor: "#D50000",

    inactiveBackgroundColor: "#3C3C3C",
    inactiveBorderColor: "transparent",
    inactiveTextColor: primaryTextColor,
    activeBackgroundColor: "#3C3C3C",
    activeBorderColor: colorAccent,
    activeTextColor: primaryTextColor,
    borderRadius: 0.6,
  };

  const bottomBarStyle: Partial<BottomBarStyle> = {
    backgroundColor: "#3C3C3C",
    borderColor: "#434343",
    borderWidth: 0.05,
    activeTintColor: colorAccent,
    inactiveTintColor: primaryTextColor,
    activeFocusedTintColor: primaryTextColor,
    activeFocusedBackgroundColor: colorAccent,
    inactiveFocusedTintColor: primaryTextColor,
    scaleFactor: 1.1,
  };

  const notificationInstall: Partial<NotificationInstall> = {
    textColor: colorAccent,
  };
  const secondaryButtonStyle: Partial<ButtonStyle> = {
    fontSize: 14,
    fontWeight: 600,
    inactiveBackgroundColor: "#CFCFCF26",
    inactiveBorderColor: "transparent",
    inactiveTextColor: primaryTextColor,

    hoverBackgroundColor: "#CFCFCF50",
    hoverBorderColor: undefined,
    hoverTextColor: "#ffffff",

    activeBackgroundColor: colorAccent,
    activeBorderColor: "none",
    activeTextColor: "#ffffff",

    uppercased: false,
    borderRadius: 3.2,
    borderWidth: 0.2,

    scaleFactor: 1.05,
  };
  const toggleButtonStyle: Partial<ToggleButtonStyle> = {
    ...secondaryButtonStyle,
    inactiveBackgroundColor: cardStyle.inactiveBackgroundColor,
  };
  return {
    name: "dark",
    default: {
      backgroundColor: "#2D2D2D",
      inverseBackgroundColor: "#F2F2F2",
      logoSize: { width: 11.0, height: 2.4 },
      logoAISSize: { width: 15.7, height: 2.4 },
      spinnerColor: colorAccent,
      rippleColor: colorAccent,
      notificationInstall,
      images: {
        Logo: Logo,
        LogoAIS: LogoAIS,
        multiplayer: MultiPlayer,
        multiplayer_active: MultiPlayerActive,
        gamepad: Gamepad,
        gamepad_active: GamepadActive,
        touch: Touch,
        touch_active: TouchActive,
        keyboard_mouse: KeyboardMouse,
        keyboard_mouse_active: KeyboardMouseActive,
        tv_remote: TvRemote,
        tv_remote_active: TvRemoteActive,
        TimerShort,
        TimerMedium,
        TimerLong,
        TimerShortActive,
        TimerMediumActive,
        TimerLongActive,

        Plans: Plans,
        PlansActive: PlansActive,

        Newsletter: Newsletter,
        NewsletterActive: NewsletterActive,

        Receipt: Receipt,
        ReceiptActive: ReceiptActive,

        Settings: Settings,
        SettingsActive: SettingsActive,

        Link: Link,
        LinkActive: LinkActive,

        Visibility: Visibility,
        VisibilityOff: VisibilityOff,

        Faq: Faq,
        FaqActive: FaqActive,

        Discord: Discord,

        Support: Support,
        SupportActive: SupportActive,

        Notification: Notification,
        NotificationActive: NotificationActive,

        LightTheme: LightTheme,
        LightThemeActive: LightThemeActive,

        DarkTheme: DarkTheme,
        DarkThemeActive: DarkThemeActive,

        SortAZ,
        SortAZDark,
        SortAZActive,
        SortDate,
        SortDateDark,
        SortDateActive,
        SortGenre,
        SortGenreDark,
        SortGenreActive,
        Account,
        AccountActive,
        NotificationsPush,
        SwitchProfile,
        SwitchProfileActive,
        Speedtest,
        SpeedtestActive,
        PEGI_3,
        PEGI_7,
        PEGI_12,
        PEGI_16,
        PEGI_18,
        PEGI_3_Active,
        PEGI_7_Active,
        PEGI_12_Active,
        PEGI_16_Active,
        PEGI_18_Active,
        NewsletterIcon,
        MultiDevice,
        LogoGameloft,
      },
      statusBarStyle: {
        translucent: true,
        backgroundColor: "transparent",
        style: "light-content",
      },

      buttonTextStyle: {
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      },

      textStyle: {
        size: 1.8,
        color: primaryTextColor,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", Arial, sans-serif',
      },

      textStyle2: {
        size: 1.4,
        color: "#9D9D9D",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", Arial, sans-serif',
      },

      textStyle3: {
        size: 1.2,
        color: primaryTextColor,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", Arial, sans-serif',
      },

      titleTextStyle: {
        size: 3.6,
        color: primaryTextColor,
        fontWeight: 600,
      },

      sectionTextStyle: {
        size: 2,
        fontWeight: 700,
        labelStyle: {
          inactiveFontSize: 15,
          activeFontSize: 12,
          activeColor: primaryTextColor,
          inactiveColor: primaryTextColor,
        },

        helperStyle: {
          size: 12,
          color: "#fff",
        },

        errorColor: "#D50000",

        inactiveBackgroundColor: "#3C3C3C",
        inactiveBorderColor: "transparent",
        inactiveTextColor: primaryTextColor,
        activeBackgroundColor: "#3C3C3C",
        activeBorderColor: colorAccent,
        activeTextColor: primaryTextColor,
        borderRadius: 0.4,

        color: primaryTextColor,
      },

      headerStyle: {
        backgroundColor: "#2D2D2D",
        textStyle: {
          color: primaryTextColor,
          size: 1.8,
          fontWeight: 500,
        },
        buttonsTintColor: "#ffffff",
        elevation: 0,
        borderColor: "#434343",
        borderWidth: 0.1,
      },
      titleListStyle: {
        size: 1.8,
        fontWeight: 600,
        color: primaryTextColor,
      },
      bottomBarStyle,

      separatorColor: "#737373",
      textColor: primaryTextColor,

      navigationBar: {
        backgroundColor: "#3C3C3C",
        lightContent: true,
      },

      listStyle: {
        backgroundColor: "#3C3C3C",
        textColor: primaryTextColor,
        acessoryViewTintColor: colorAccent,
        radius: 0.6,
        activeBackgroundColor: colorAccent,
        activeTextColor: "#fff",
      },

      primaryButton: {
        inactiveBackgroundColor: colorAccent,
        inactiveBorderColor: undefined,
        inactiveTextColor: primaryTextColor,

        activeBackgroundColor: colorAccent,
        activeBorderColor: undefined,
        activeTextColor: "#fff",

        hoverBackgroundColor: "#ba0a3b",
        hoverBorderColor: undefined,
        hoverTextColor: "#FFFFFF",

        fontSize: 14,
        fontWeight: 700,

        uppercased: false,
        borderRadius: 3.2,

        scaleFactor: 1.05,
        borderWidth: 0,
      },

      secondaryButton: {
        fontSize: 14,
        fontWeight: 600,
        inactiveBackgroundColor: "#CFCFCF26",
        inactiveBorderColor: "transparent",
        inactiveTextColor: primaryTextColor,

        hoverBackgroundColor: "#CFCFCF50",
        hoverBorderColor: undefined,
        hoverTextColor: "#ffffff",

        activeBackgroundColor: colorAccent,
        activeBorderColor: "none",
        activeTextColor: "#ffffff",

        uppercased: false,
        borderRadius: 3.2,
        borderWidth: 0.2,

        scaleFactor: 1.05,
      },

      tertiaryButton: {
        inactiveBackgroundColor: undefined,
        inactiveBorderColor: undefined,
        inactiveTextColor: colorAccent,

        activeBackgroundColor: colorAccent,
        activeBorderColor: colorAccent,
        activeTextColor: primaryTextColor,
        fontSize: 14,
        fontWeight: 600,

        uppercased: false,

        scaleFactor: 1.05,

        borderRadius: 3.2,
      },
      iconButton: {
        inactiveBackgroundColor: "#CFCFCF15",
        inactiveBorderColor: colorAccent,
        inactiveTextColor: "#191414",

        hoverBackgroundColor: "#CFCFCF50",
        hoverBorderColor: undefined,
        hoverTextColor: "#191414",

        activeBackgroundColor: colorAccent,
        activeBorderColor: undefined,
        activeTextColor: "#FFFFFF",

        fontSize: 14,
        fontWeight: 700,
        borderWidth: 0,
        uppercased: false,
        borderRadius: 3.2,
        scaleFactor: 1.01,
      },
      textInputStyle: {
        ...textInputStyle,
      },

      cardStyle: {
        ...cardStyle,
      },
      categoryTileCardStyle: {
        ...cardStyle,
        inactiveBackgroundColor: "#454545",
        inactiveTextColor: "#FFFFFF",
        activeBackgroundColor: "#454545",
        activeTextColor: "#FFFFFF",
      },

      accountCardStyle: {
        ...cardStyle,
        scaleFactor: 1.02,
      },
      profileCardStyle: {
        ...cardStyle,
        scaleFactor: 1.01,
      },
      tileCardStyle: {
        ...cardStyle,
        radius: 0.6,
        scaleFactor: 1.02,
      },
      profileListItemCardStyle: {
        ...cardStyle,
        scaleFactor: 1.01,
      },
      browseCardItemCardStyle: {
        ...cardStyle,
        scaleFactor: 1.03,
      },
      checkboxStyle: {
        activeTintColor: colorAccent,
        inactiveTintColor: "#fff",
      },
      toggleButton: toggleButtonStyle,
      modalStyle: {
        backgroundColor: "#2D2D2D",
        overlayColor: "#19141450",
        padding: 3.2,

        titleTextStyle: {
          size: 2,
          color: primaryTextColor,
          fontWeight: 600,
          colorAccent: colorAccent,
        },

        textStyle: {
          size: 14,
          color: primaryTextColor,
        },

        buttonsAlignment: "end",
      },
      tabStyle: {
        activeBorderColor: colorAccent,
        inactiveBorderColor: "transparent",
        textStyle: {
          fontSize: 14,
          activeTextColor: colorAccent,
          inactiveTextColor: primaryTextColor,
        },
      },

      switchStyle: {
        activeThumbColor: colorAccent,
        inactiveThumbColor: "#9D9D9D",
        activeTrackColor: "#CFCFCF",
        inactiveTrackColor: "#CFCFCF",
      },

      fullscreenControls: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
      },

      search: {
        toggleButtonStyle: {
          ...toggleButtonStyle,
        },
        iconSearchInput: {
          size: 2.2,
        },
        textInputStyle: {
          ...textInputStyle,
          inactiveBackgroundColor: "#2D2D2D",
        },
      },

      inputPinStyle: {
        borderColor: "#CFCFCF",
      },

      speedTestStyle: {
        colors: {
          unknown: cardStyle.inactiveBackgroundColor,
          ok: "#b9e081",
          warn: "#f5d181",
          bad: "#fb9f9f",
        },
      },

      notificationPWA: {
        textColor: primaryTextColor,
        backgroundColor: "#3C3C3C",
      },

      labelSecureStyle: {
        color: "#856404",
        backgroundColor: "#fff3cd",
      },

      visibilityInputIconColor: "#fff",
    },

    phone: {
      titleTextStyle: {
        size: 2.8,
      },
      sectionTextStyle: {
        size: 1.6,
        fontWeight: 600,
      },
      titleListStyle: {
        size: 1.6,
        fontWeight: 600,
        color: primaryTextColor,
      },
      modalStyle: {
        padding: 2.4,
      },

      search: {
        toggleButtonStyle,
        textInputStyle: {
          ...textInputStyle,
          inactiveBackgroundColor: "#3C3C3C",
        },
      },

      bottomBarStyle: {
        ...bottomBarStyle,
      },
    },
    tablet: {
      search: {
        toggleButtonStyle,
        textInputStyle: {
          ...textInputStyle,
          inactiveBackgroundColor: "#3C3C3C",
        },
      },
    },
  } as NamedTheme;
};

export default createDarkTheme({ colorAccent: "#EB2553" });
